import { UUID_PATTERN } from './uuidPattern'

/**
 * Extract an inventory product UUID from QR / pasted scan payloads.
 *
 * Supported formats:
 * - Raw UUID: `xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx`
 * - HTTPS (or HTTP) URL whose path contains `/scan/<uuid>` (e.g. share links to the scan route)
 * - Query params `productId=<uuid>` or `id=<uuid>` on a parseable URL (scheme added if missing)
 *
 * Invalid URLs or non-matching text return `null` (fail silently so scanning can continue).
 */
export function extractProductIdFromScanPayload(value: string): string | null {
  const raw = value.trim()
  if (!raw) return null

  const direct = raw.match(UUID_PATTERN)
  if (direct?.[0]) return direct[0]

  const normalized = raw.startsWith('http://') || raw.startsWith('https://')
    ? raw
    : `https://${raw}`

  try {
    const url = new URL(normalized)
    const pathMatch = url.pathname.match(/\/scan\/([0-9a-f-]{36})/i)
    if (pathMatch?.[1]) return pathMatch[1]

    const qp = url.searchParams.get('productId') || url.searchParams.get('id')
    if (qp && UUID_PATTERN.test(qp)) {
      const match = qp.match(UUID_PATTERN)
      return match?.[0] || null
    }
  } catch {
    return null
  }

  return null
}
